import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLoaderData } from "react-router";

import classNames from "classnames";

import { store } from "../..";
import "../../assets/css/wibb/pages/tournaments.scss";
import Schedule from "../../components/Schedule";
import { globalActions } from "../../features/global/globalSlice";
import {
    selectSelectedTournament,
    tournamentManagementActions,
} from "../../features/tourneymgmt/tournamentManagementSlice";
import { getTournamentSchedule } from "../../lib/api";
import { PrintIcon } from "../../lib/icons";
import { ITournament, ITournamentSchedule } from "../../types/api";

export const loader = async ({ params }: any) => {
    const { tournamentId } = params;
    const promises = [];

    let tournaments = store.getState().tournamentmanagement.tournaments;
    let masterTournaments =
        store.getState().tournamentmanagement.masterTournaments;
    const fields = store.getState().global.fields;

    !tournaments.length &&
        promises.push(
            store.dispatch(tournamentManagementActions.getTournaments()),
        );
    !masterTournaments.length &&
        promises.push(
            store.dispatch(tournamentManagementActions.getMasterTournaments()),
        );
    !fields.length && promises.push(store.dispatch(globalActions.getFields()));

    const [{ schedule }] = await Promise.all([
        getTournamentSchedule(tournamentId),
        ...promises,
    ]);

    if (!tournaments.length) {
        tournaments = store.getState().tournamentmanagement.tournaments;
    }

    if (!masterTournaments.length) {
        masterTournaments =
            store.getState().tournamentmanagement.masterTournaments;
    }

    store.dispatch(
        tournamentManagementActions.setselectedTournamentId(
            parseInt(tournamentId),
        ),
    );

    const tournament = selectSelectedTournament(
        store.getState(),
    ) as ITournament;

    const masterTournament = masterTournaments.find(
        t => t.id === tournament.parent,
    );

    const header = `${masterTournament?.name} ${tournament.ageLevel} Schedule`;

    return {
        schedule,
        header,
    };
};

const TournamentSchedule = (): React.JSX.Element => {
    const { schedule } = useLoaderData() as { schedule: ITournamentSchedule };

    return (
        <div
            data-testid="tournamentScheduleContent"
            className={classNames("tournamentScheduleContent")}
        >
            <Container fluid="xs">
                <Row>
                    <Col>
                        <div
                            className={classNames("d-flex", "mb-2", "noPrint")}
                        >
                            <PrintIcon
                                className="printerIcon d-none d-lg-inline-block"
                                size="2x"
                                title="Print schedule"
                                onClick={() => window.print()}
                            />
                        </div>
                        {schedule?.games ? (
                            <Schedule
                                schedule={schedule?.games.filter(
                                    g => !["Deleted"].includes(g.status),
                                )}
                                scheduleType="tournament"
                            />
                        ) : (
                            <h2>No scheduled games</h2>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default TournamentSchedule;
